// import "jquery-touchswipe/jquery.touchSwipe";
// import "bootstrap";

/* eslint-disable-next-line */
(function ($) {
	$(document).ready(function () {

		let headerScrollTopOffset = 0;

		if ($("body").hasClass("admin-bar") && ($(window).width() > 600)) {
			headerScrollTopOffset = parseInt($("html").css("margin-top"));
		}

		// If current page is a single tour post type page, apply sticky header
		// functionality to tour info header instead of site header navbar.
		if ($("body").hasClass("single-rit-tour") && ($(window).width() >= 992)) {

			let tour_header_start_height = Math.ceil($("body.single-rit-tour > .main > .tour-header-wrap .stickied-content-swap-wrap").outerHeight());

			$("body.single-rit-tour > .main > .tour-header-wrap .stickied-content-swap-wrap").height(tour_header_start_height);

			if ($(window).width() < 1200) {

				$("body.single-rit-tour > .main > .tour-header-wrap")
					.css("--sticky-top-offset", tour_header_start_height + "px")
					.css("height", Math.round($("body.single-rit-tour > .main > .tour-header-wrap").outerHeight()) + "px");

				headerScrollTopOffset = headerScrollTopOffset - tour_header_start_height;

			}
			console.log(headerScrollTopOffset);
			// Watch for when tour info header is scrolled to or away from the top of the viewport.
			// If header is scrolled to the top of the page, we know it's been stickied based on it having position: sticky.
			// Add class when it's sitting at the top of the page, remove it when it's been scrolled away.
			// Also swap visibility of stickied and unstickied content containers.
			$("body.single-rit-tour > .main > .tour-header-wrap").observeScrollTopChanges(headerScrollTopOffset).on("scroll-top-change", (evt) => {

				$(evt.target).toggleClass("sticky", evt.detail.scrolledToTop);

				if ($(window).width() >= 1200) {
					swap_stickied_content(evt.target, evt.detail.scrolledToTop);
				}

			});

		} else {

			// Watch for when header is scrolled to or away from the top of the viewport
			// If header is scrolled to the top of the page, we know it's been stickied based on it having position: sticky
			// Add class when it's sitting at the top of the page, remove it when it's been scrolled away
			$("body > header").observeScrollTopChanges(headerScrollTopOffset).on("scroll-top-change", (evt) => {

				$(evt.target).toggleClass("sticky", evt.detail.scrolledToTop);

			});

		}

		/**
		* Back to top button - scroll functionality
		*/

		let backToTopButton = $('#back-to-top');

		backToTopButton.addClass('fade').on('click', function () {
			$('html, body').animate(
				{
					scrollTop: 0,
				},
				400
			);
		});

		/**
		 * Back to top button - show/hide functionality
		 */

		let debounce;

		$(document).on('scroll', function () {

			//clear the delay if it's not finished yet
			if (debounce) {
				clearTimeout(debounce);
			}

			//start a new delay
			debounce = setTimeout(function () {
				//remove reference so another delay can start
				debounce = null;

				// show/hide the button
				if ($(window).scrollTop() > 200) {
					backToTopButton.addClass('show');
				} else {
					backToTopButton.removeClass('show');
				}
			}, 200);
		});


		/**
		 * Play/Pause buttons
		 */

		$(".btn-play-pause").on("click", function () {

			let currState = $(this).attr("data-state");

			const pauseUnpauseEvt = new CustomEvent("play-pause-state-changed", { detail: { clickedState: currState } });

			$(this).get(0).dispatchEvent(pauseUnpauseEvt);

			let newState = (currState === "pause") ? "play" : "pause";

			$(this).attr("data-state", newState);

			$(this).children(".state-label").text($(this).children(".state-label").data(newState + "-label"));

		});


		/**
		 * Page Banner  Carousel
		 */
		if ($(".page-header").has(".banner-bg-carousel").length > 0) {

			$(".page-header").has(".banner-bg-carousel").each(function () {

				let pageBannerPlayPauseBtn = $(".btn-play-pause", this);
				let pageBannerCarousel = new bootstrap.Carousel($(".banner-bg-carousel", this).get(0));

				pageBannerPlayPauseBtn.on("play-pause-state-changed", function (evt) {

					let currPausePlayState = evt.detail.clickedState;

					if (currPausePlayState === "pause") {
						pageBannerCarousel.pause();
					} else {
						pageBannerCarousel.cycle();
					}

				});

			});
		}

		if ($(".page-header").has(".banner-video-container").length > 0) {

			$(".page-header").has(".banner-video-container").each(function () {

				let pageBannerPlayPauseBtn = $(".btn-play-pause", this);
				let pageBannerVideoElement = $(".banner-video", this).get(0);

				pageBannerPlayPauseBtn.on("play-pause-state-changed", function (evt) {

					let currPausePlayState = evt.detail.clickedState;

					if (currPausePlayState === "pause") {
						pageBannerVideoElement.pause();
					} else {
						pageBannerVideoElement.play();
					}

				});

			});

		}

		/**
		 * Post Slider - Bootstrap mods
		 */
		$('.post-slider .carousel-inner .carousel-item:first-of-type').addClass('active');

		$.each($('.post-slider-block .post-slider'), function (index, slider) {
			var sliderID = '#' + $(slider).attr('id');
			/*
				CC 2.0 License Iatek LLC 2018 - Attribution required
			*/
			$(this).on('slide.bs.carousel', function (e) {
				var $e = $(e.relatedTarget);
				var idx = $e.index();
				var itemsPerSlide = 5;
				var totalItems = $(sliderID + ' .carousel-item').length;

				if (idx >= (totalItems - (itemsPerSlide - 1))) {
					var it = itemsPerSlide - (totalItems - idx);
					for (var i = 0; i < it; i++) {

						// append slides to end
						if (e.direction === "left") {
							$(sliderID + ' .carousel-item').eq(i).appendTo(sliderID + ' .carousel-inner');
						} else {
							$(sliderID + ' .carousel-item').eq(0).appendTo(sliderID + ' .carousel-inner');
						}
					}
				}
			});
		});

	});

	let swap_stickied_content = function (stickied_element, is_stickied) {

		let content_wrap = $(".stickied-content-swap-wrap", stickied_element);

		let unstickied_content = content_wrap.children(".unstickied-content");
		let stickied_content = content_wrap.children(".stickied-content");

		if (is_stickied) {

			content_wrap.css("height", Math.ceil(stickied_content.outerHeight()) + "px");

			unstickied_content.removeClass("show").attr("aria-hidden", true);
			stickied_content.addClass("show").attr("aria-hidden", false);

		} else {

			content_wrap.css("height", Math.ceil(unstickied_content.outerHeight()) + "px");

			unstickied_content.addClass("show").attr("aria-hidden", false);
			stickied_content.removeClass("show").attr("aria-hidden", true);

		}
	};

	// Fires event when element has scrolled up to or away from the top of it's parent
	$.fn.observeScrollTopChanges = function (offset = 0) {

		// Top and bottom margin values position marker element at the top of the box area of the current element, regardless of it's top margin
		// Need to increase bottom margin's negative value by 1px to compensate for marker's height
		// Essentially makes the marker invisible
		const marker = $("<div>").css({
			"margin-top": this.css("marginTop"),
			"margin-bottom": ((parseInt(this.css("marginTop")) + 1) * -1),
			"height": "1px",
		});

		if (offset !== 0) {
			marker.css({
				"position": "relative",
				"top": ((offset + 1) * -1),
			});
		}

		// Add to DOM before element being observed
		// When marker is hidden beyond the top of the viewport, the target element will be touching the top of the viewport
		this.before(marker);

		// Create observer object
		const scrollTopObserver = new IntersectionObserver((entries) => {

			// Width, height and scroll position of element being observed
			const targetBoundingRect = entries[0].boundingClientRect;
			// Width height and position of viewport
			const viewportBoundingRect = entries[0].rootBounds;

			// The element that should have the event triggered on it
			// Basically, the element that we want to know when it has reached the top of the page on scroll
			const evtTrigger = entries[0].target.nextSibling;

			let scrolledToTop = false;

			// If the entire marker element has scrolled beyond the top of the viewport
			if (targetBoundingRect.bottom < viewportBoundingRect.top) {

				scrolledToTop = true;

				// If the entire marker element is visible again
			} else if (targetBoundingRect.bottom >= viewportBoundingRect.top) {

				scrolledToTop = false;

			}

			// Create custom event and pass information about whether the element was just hit the top of the page or if it is being scrolled away
			const evt = new CustomEvent("scroll-top-change", { detail: { scrolledToTop: scrolledToTop } });

			evtTrigger.dispatchEvent(evt);

			// Threshold says how much of the element needs to be visible before checking for intersection
			// 0 means as soon as any part of the element is visible
		}, { threshold: [0] });

		// Start observing the marker element
		scrollTopObserver.observe(marker.get(0));

		// Return current element to allow for jQuery function chaining
		return this;

	};

	/* eslint-disable-next-line */
})(jQuery);

